export default __webpack_public_path__ + "static/media/Frame.1ce6bccf.svg";